import { Box, Drawer, DrawerProps, Stack, StackProps, styled, Typography, TypographyProps } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Divider } from '../../atoms/layout';
import { Button } from '../../atoms/buttons';

type DrawerLayoutProps = DrawerProps & {
  loading?: boolean;
};
export function DrawerLayout({ loading, ...props }: DrawerLayoutProps) {
  return (
    <Drawer anchor="right" {...props}>
      {loading ? (
        <DrawerContent height="100%" justifyContent="center" alignItems="center">
          <CircularProgress />
        </DrawerContent>
      ) : (
        <Box height="100%" pt={2}>{props.children}</Box>
      )}
    </Drawer>
  );
}

type DrawerHeaderProps = TypographyProps & {};
export function DrawerHeader({ children, ...props }: DrawerHeaderProps) {
  return (
    <Typography variant="h6" {...props} aria-label="drawer-header">
      {children}
    </Typography>
  );
}

type DrawerStatusStripeProps = StackProps & {};
export function DrawerStatusStripe({ children, ...props }: DrawerStatusStripeProps) {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" height="24px" {...props} aria-label="drawer-status-stripe">
      {children}
    </Stack>
  );
}

type DrawerPaneProps = StackProps & {};
export function DrawerPane({ children, ...props }: DrawerPaneProps) {
  return (
    <DrawerPaneStyledStack direction="column" {...props} aria-label="drawer-pane">
      {children}
      <Box flex={1} />
    </DrawerPaneStyledStack>
  );
}

const DrawerPaneStyledStack = styled(Stack)(({ theme }) => ({
  overflow: 'auto',
}));

type DrawerContentProps = StackProps & {};
export function DrawerContent({ children, ...props }: DrawerContentProps) {
  return (
    <DrawerContentStyledStack direction="column" width={{ xs: '400px', sm: '650px' }} {...props} aria-label="drawer-content">
      {children}
    </DrawerContentStyledStack>
  );
}

const DrawerContentStyledStack = styled(Stack)(({ theme }) => ({
  height: '100%',
  maxHeight: '100%',
  overflow: 'hidden',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

type DrawerControlsPaneProps = StackProps & {};
export function DrawerControlsPane({ children, ...props }: DrawerControlsPaneProps) {
  return (
    <DrawerControlsStyledStack direction="column" width={'100%'} {...props} aria-label="drawer-controls-pane">
      <Divider sx={{ mt: 0, mb: 2 }} />
      {children}
    </DrawerControlsStyledStack>
  );
}
const DrawerControlsStyledStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(2),
}));

export const DrawerControlButton = styled(Button)(({ theme }) => ({
  // minWidth: theme.spacing(16.75),
}));
